module.exports = __webpack_public_path__ + "static/media/sample.9b8ad258.jpg";